import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import ModalContainer from '../../ModalContainer/ModelContainer'
import RadioField from '../../FormLegacy/FormFieldsV2/RadioField'
import { formatMoney } from '../../../helpers/helpers'

const ConfirmDeleteModal = ({ attendeeToDelete, onClose, onConfirm }) => {
  const { t } = useTranslation(['attendees', 'common'])
  const [withRefund, setWithRefund] = useState(false)

  if (!attendeeToDelete) {
    return null
  }

  const helperText = attendeeToDelete.hasGuests
    ? t('attendees:confirmDeleteModal.helperTextWithGuests', { name: attendeeToDelete.name })
    : t('attendees:confirmDeleteModal.helperText', { name: attendeeToDelete.name })

  return (
    <ModalContainer
      onClose={onClose}
      headerTitle={t('attendees:confirmDeleteModal.title')}
      isVisible={!!attendeeToDelete}
      additionalClass="attendee_delete-confirm-modal"
      headerClassName="attendee_delete-confirm-modal__header"
    >
      <div className="attendee_delete-confirm-modal__content">
        <p>{helperText}</p>
        {!attendeeToDelete.isFreeTicket && (
          <React.Fragment>
            <RadioField
              type="radio"
              name="a"
              label={
                attendeeToDelete.amountToRefund
                  ? t('attendees:confirmDeleteModal.removeWithRefundAmount', {
                      amount: formatMoney(attendeeToDelete.amountToRefund),
                    })
                  : t('attendees:confirmDeleteModal.removeWithRefund')
              }
              onChange={() => setWithRefund(true)}
              checked={withRefund}
            />
            <RadioField
              type="radio"
              name="b"
              label={t('attendees:confirmDeleteModal.removeWithoutRefund')}
              onChange={() => setWithRefund(false)}
              checked={!withRefund}
            />
          </React.Fragment>
        )}

        <div className="attendee_delete-confirm-modal__buttons">
          <button className="button button-gray" onClick={onClose}>
            {t('common:actions.cancel')}
          </button>
          <button
            className="button button-orange"
            onClick={() => onConfirm(attendeeToDelete.id, attendeeToDelete.role, withRefund)}
          >
            {t('attendees:confirmDeleteModal.yesRemove')}
          </button>
        </div>
      </div>
    </ModalContainer>
  )
}

ConfirmDeleteModal.propTypes = {
  attendeeToDelete: PropTypes.object,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
}

export default ConfirmDeleteModal
